export default __webpack_public_path__ + "static/media/ce-3.4a20ec7e.png";